import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { OrderResultContainer } from "./component/styled/setting";

const MenuBoardFail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cmpnyNo } = useParams();

  const search = new URLSearchParams(location.search);
  const code = search.get("code") || "UNKNOWN_ERROR";
  const message = search.get("message") || "결제에 실패했습니다.";

  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    const redirect = setTimeout(() => navigate(`/menu-board/${cmpnyNo}/cart`), 10000);
    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <OrderResultContainer>
      <strong className="tit">결제 실패</strong>
      <p>
        [코드] {code}
        <br />
        [메시지] {decodeURIComponent(message)}
      </p>
      <p>문제가 발생했습니다.</p>
      <p>
        <strong>{countdown}</strong>초 후 장바구니로 이동합니다.
      </p>
      <button onClick={() => navigate(`/menu-board/${cmpnyNo}/cart`)}>바로 이동</button>
    </OrderResultContainer>
  );
};

export default MenuBoardFail;
